/**
 * /tenants/$slug/authentication/conditional-access/$policyId — edit route.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchPolicy } from "@/features/policies/queries";
import { queryKeys } from "@/lib/query-keys";
import { PolicyEditorPage } from "@/features/policies/pages/policy-editor-page";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/conditional-access/$policyId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.policies.detail(context.tenant.id, params.policyId),
      queryFn: () => fetchPolicy(context.tenant.id, params.policyId),
    }),
  component: () => <PolicyEditorPage mode="edit" />,
});
